import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { UserPlatformProfile } from "types/interfaces/user";

export interface ClientViewState {
  active: boolean;
  userId: number | null;
  displayName: string;
  profile: UserPlatformProfile | null;
}

export interface SetClientViewPayload {
  userId: number;
  displayName: string;
  profile: UserPlatformProfile;
}

const initialState: ClientViewState = {
  active: false,
  userId: null,
  displayName: "",
  profile: null,
};

const clientViewSlice = createSlice({
  name: "clientView",
  initialState,
  reducers: {
    setClientView: (state, action: PayloadAction<SetClientViewPayload>) => {
      state.active = true;
      state.userId = action.payload.userId;
      state.displayName = action.payload.displayName;
      state.profile = action.payload.profile;
    },
    clearClientView: () => initialState,
  },
});

export const { setClientView, clearClientView } = clientViewSlice.actions;
export default clientViewSlice.reducer;
